import React, { useContext } from 'react'
import { HeaderContext } from './HeaderContext'
import { VscClose, VscMenu } from 'react-icons/vsc'

const Toggle = () => {
	const { $open, set$open } = useContext(HeaderContext)

	return (
		<button
			className="[grid-area:toggle] md:hidden p-4 text-2xl"
			onClick={() => set$open(!$open)}
		>
			{$open ? <VscClose /> : <VscMenu />}
		</button>
	)
}

export default Toggle
